/**
 * Easing functions for animation interpolation
 */

/**
 * Linear interpolation - no easing
 */
export const linear = (t: number): number => t;

/**
 * Ease in out cubic - smooth acceleration and deceleration
 * Used for most UI animations
 */
export const easeInOutCubic = (t: number): number => {
	return t < 0.5
		? 4 * t * t * t
		: 1 - ((((-2 * t) + 2) ** 3) / 2);
};

/**
 * Ease in cubic - starts slow, accelerates
 */
export const easeInCubic = (t: number): number => t * t * t;

/**
 * Ease out cubic - starts fast, decelerates
 */
export const easeOutCubic = (t: number): number => 1 - ((1 - t) ** 3);

/**
 * Ease in out quad - smoother than cubic, less pronounced
 */
export const easeInOutQuad = (t: number): number => {
	return t < 0.5
		? 2 * t * t
		: 1 - ((((-2 * t) + 2) ** 2) / 2);
};

/**
 * V-shaped curve - useful for intensity that dips in the middle
 * Returns 1 at t=0, 0 at t=0.5, 1 at t=1
 */
export const vCurve = (t: number): number => Math.abs((2 * t) - 1);

/**
 * Inverted V-curve - peaks in the middle
 * Returns 0 at t=0, 1 at t=0.5, 0 at t=1
 */
export const invertedVCurve = (t: number): number => 1 - Math.abs((2 * t) - 1);

export type EasingFunction = (t: number) => number;

